<template>
 <div class="wrap talk re-style">
		<header>
			<h1><a href="#" class="logo"></a></h1>
		</header>
		<div class="container">
			<main class="content">
				<article class="certification">
					<section class="txt">
						<h2>PASS 본인인증 실패</h2>
					</section>
					<section class="">
						<div class="box row row_c row_jsc">
							<h1 v-if="passType == '5'">아래 내용을 확인 후 재시도 해주세요</h1>
							<h1 v-else>아래 내용을 확인 해주세요</h1>
             <div class="box-checklist">
                <p>[확인사항]</p>
                <ol>
                  <li> 기본 브라우저 설정에서 "모든 쿠키 허용"으로 설정되어 있는지 확인해주세요.</li>
                  <li> 기본 브라우저 → 설정 → 사이트 및 다운로드 → 사이트 권한 → 쿠키 → 모든 쿠키 허용 (브라우저 종류에 따라 설정 방법은 다를 수 있습니다.)</li>
                  <li> 민팃 App에 입력한 휴대폰번호와 PASS 인증한 휴대폰번호를 동일하게 입력해주세요. </li>
                </ol>
              </div>
						</div>
						<div class="btn-wrap" v-if="passType == '5'">
						<a href="javascript:void(0);" class="talk-btn btn-black" @click.stop.prevent="certPass()">휴대폰 인증</a>
					</div>            
					</section>
				</article>
			</main>
		</div>
	</div>
</template>

<script>
import Vue from 'vue'
import AppConfig from '@/config'

export default {
  name: 'CrtfPassFail',
  components: {  },
  data: () => ({
	AppConfig: AppConfig,
    certPassDvsn: '4',
    ordNum: '',
    passType:'',

  }),
  computed: {

  },
  mounted() {
    	this.certPassDvsn = this.$route.query.certPassDvsn
    	this.passType = this.$route.query.passType
        this.ordNum = this.$route.query.ordNum ? this.$route.query.ordNum  : ''
  },
  methods: {
   
    Close(){

				var ua = navigator.userAgent.toLowerCase();

				console.log( "====> Close Calling!!! ")

				if(ua.indexOf("kakaotalk") > -1){
					if(ua.indexOf("iphone") > -1||ua.indexOf("ipad") > -1||ua.indexOf("ipod") > -1){
						window.location.href = "kakaoweb://closeBrowser";
					}else{
						window.location.href = "kakaotalk://inappbrowser/close";
					}
				}else{
					window.opener.close();
					window.close();
				}
			},
		async certPass () {
	      const params = {
	        prncCrtfNum : this.$route.query.enCodePrncCrtfNum ? this.$route.query.enCodePrncCrtfNum : this.$route.query.prncCrtfNum,
	        passReTry: 'Y',
	        passType    : this.$route.query.passType ? this.$route.query.passType : "",
        	ord_number    : this.$route.query.ord_number ? this.$route.query.ord_number : ""
	      }
	
	      const rtn = await Vue.httpClient
	        .get('/api/purchase/crtfNeo/public/crtfPassOvertime', {params})
	        .then(res => {
	          if (res.data.status === AppConfig.HTTP_RESPONSE_SUCCESS) {
	            if (res.data.result) {
	              console.log(res.data.result)
	              const rs = res.data.result;
	
	              if(this.$route.query.passType)
	                this.afterOthers(rs)
	              else
	              {
	                // if(rs.certMinCheck == "CERT" && rs.prncCrtfCmplDt == "" && rs.clphNum == null) {
	                if (rs.certMinCheck == "CERT" && (rs.prncCrtfCmplDt == null || rs.prncCrtfCmplDt == "")) {
	                  this.formSubmit(rs)// 팝업 창
	                } else if (rs.crtfConfYn == "Y") {
	                  Vue.Alert.alert("이미 인증처리 되었습니다.")
	                } else if (rs.certMinCheck == "CERT" && (rs.prncCrtfCmplDt != null && rs.prncCrtfCmplDt != "")) {
	                  Vue.Alert.alert("본인인증이 완료되었습니다. " + rs.rdnmKey + "(을)를 ATM에 입력해 주세요.")
	                } else if (rs.certMinCheck == "NOTCERT") {
	                  Vue.Alert.alert("인증 유효 시간이 만기 되었습니다.(5분) ATM 에서 다시 시작해 주시기 바랍니다.")
	                } else if (rs.clphNum != null) {   // 이 조건은 다시 확인 필요.
	                  Vue.Alert.alert("ATM 에서 입력한 핸드폰 번호와 인증받으신 핸드폰 번호가 다릅니다. ATM 에서 다시 시작해 주시기 바랍니다.");
	                } else {
	                  Vue.Alert.alert("ATM 에서 다시 시작해 주시기 바랍니다.")
	                }
	              }
	            }
	          }
	        })
	    },
	    afterOthers(rs) {
	      // if(rs.certMinCheck == "CERT" && rs.prncCrtfCmplDt == "" && rs.clphNum == null) {
	      if (rs.certMinCheck === "CERT" && !rs.prncCrtfCmplDt)
	        this.formSubmit(rs);
	      else if (rs.crtfConfYn === "Y")
	        Vue.Alert.alert("이미 인증처리 되었습니다.")
	      else if (rs.certMinCheck === "CERT" && rs.prncCrtfCmplDt)
	        switch (this.$route.query.passType) {
	          case "3":
	            Vue.Alert.alert("이미 완료된 접수건입니다.")
	            break;
	          default:
	            Vue.Alert.alert("이미 완료 되었습니다.")
	            break;
	        }
	      else if (rs.certMinCheck === "NOTCERT")
	        Vue.Alert.alert("인증 유효 시간이 만기 되었습니다.(5분) 처음부터 다시 시작 해 주세요.")
	      else if (rs.clphNum != null)    // 이 조건은 다시 확인 필요.
	        Vue.Alert.alert("처음 입력한 핸드폰 번호와 인증받으신 핸드폰 번호가 다릅니다. 처음부터 다시 시작 해 주세요.");
	      else
	        Vue.Alert.alert("처음부터 다시 진행 해 주세요.")
	
	    },
	
	    async certPassInit () {
	      const params = {
	        atmId : 'bos_test',
	        prncCrtfNum : window.btoa('XADLAo0zndl4moDY1YzGmA=='),
	        passType    : this.$route.query.passType ? this.$route.query.passType : ""
	      }
	
	      console.log('params ==> {}', params)
	
	      const rtn = await Vue.httpClient
	        .get('/api/purchase/crtf/public/niceCrtf', {params} )
	        .then(res => {
	          if (res.data.status === AppConfig.HTTP_RESPONSE_SUCCESS) {
	            if (res.data.result) {
	              console.log(res.data.result)
	            }
	          } else {
	            Vue.Alert.alert("통신 오류 입니다.")
	          }
	        })
	
	    },
	    formSubmit( rs ) {
	
	        var mapForm = document.createElement("form");
	          mapForm.id="mapForm";
	          mapForm.target = "popupChk";
	          mapForm.method = "POST"; // or "post" if appropriate
	          mapForm.action = "https://nice.checkplus.co.kr/CheckPlusSafeModel/checkplus.cb";
	          //  mapForm.action = "http://localhost:9090/#/crtfpass/crtfPassPopup";
	
	        var mapInput1 = document.createElement("input");
	          mapInput1.type = "hidden";
	          mapInput1.name = "m";
	          mapInput1.value = "checkplusService";
	          mapForm.appendChild(mapInput1);
	
	        var mapInput2 = document.createElement("input");
	          mapInput2.type = "hidden";
	          mapInput2.name = "EncodeData";
	          mapInput2.value = rs.encData;
	          mapForm.appendChild(mapInput2);
	
	        var mapInput3 = document.createElement("input");
	          mapInput3.type = "hidden";
	          mapInput3.name = "message";
	          mapInput3.value = rs.erorMesgCtts;
	          mapForm.appendChild(mapInput3);
	
	        var mapInput4 = document.createElement("input");
	          mapInput4.type = "hidden";
	          mapInput4.name = "param_r1";   //
	          mapInput4.value = rs.prncCrtfNum;
	          mapForm.appendChild(mapInput4);
	
	        var mapInput5 = document.createElement("input");
	          mapInput5.type = "hidden";
	          mapInput5.name = "param_r2";
	          mapInput5.value = rs.rdnmKey;
	          mapForm.appendChild(mapInput5);
	
	          document.body.appendChild(mapForm);
	
	        // var map = window.open('', 'popupChk', 'width=500, height=550, top=100, left=100, fullscreen=no, menubar=no, status=no, toolbar=no, titlebar=yes, location=no, scrollbar=no');
	
	      // if (map) {
	          // mapForm.submit();
	          document.getElementById("mapForm").submit();
	      // }
	
	    },

  }
}
</script>



// WEBPACK FOOTER //
// src/views/crtfpass/CrtfPassFail.vue